import { FC } from 'react';
import { useIntl } from 'react-intl';
import { useParams } from 'react-router-dom';

import { PageTitle } from '../../../_metronic/layout/core';
import SupplierDetail from '../../modules/suppliers/components/SupplierDetail';
import SupplierAddresses from '../../modules/suppliers/components/SupplierAddresses';

type RouteParams = {
  supplierId: string;
};

const SupplierDetailPage: FC = () => {
  const intl = useIntl();
  const { supplierId } = useParams<RouteParams>();

  return (
    <>
      <PageTitle breadcrumbs={[]}>
        {intl.formatMessage({ id: 'supplierDetail.title' })}
      </PageTitle>
      <div className="row">
        <div className="col-6 d-flex flex-column gap-8">
          <SupplierDetail id={supplierId} />
        </div>
        <div className="col-6 d-flex flex-column gap-8">
          <SupplierAddresses id={supplierId} />
        </div>
      </div>
    </>
  );
};

export { SupplierDetailPage };
